import { useCallback, useMemo } from 'react';

import { globalState } from '../../../shared/foreground/models';

export default function useIsModalShown(id: string) {
  const modalToShow = globalState(useCallback((state) => state.modal, []));
  return useMemo(() => modalToShow === id, [modalToShow, id]);
}
